<template>
  <main class="about-page-wrap container">
  	<div class="row">
			<div class="col-12 white-box about-information">
        <div id="about-html" v-html="aboutHtml"></div>
			</div>

  	</div>
  </main>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      aboutHtml: false,
    }
  },
  created() {
    axios.get('https://apps.odenserundt.dk/data/odenserundt/texts/about-dk.html')
    .then((response) => {
      this.aboutHtml = response.data;
    })
    .catch(function (error) {
      console.log(error);
    });

    this.$HelperFunctions.scrollToTop();
    this.$HelperFunctions.setPageTitle('Om Odense Rundt');
  },
  mounted() {
    this.$HelperFunctions.setScreenReaderFocus();
  }
}
</script>

<style lang="scss" scoped>
  .about-page-wrap {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .about-information {
    padding: 15px 10px;
  }

  #about-html ::v-deep a {
    text-decoration: underline;
  }
</style>
